/**
 * parnasConstants.js
 * קבועים לרכיב פרנס קהילה
 */

// ─── Hebrew year display ──────────────────────────────────────────────────────
const _HEB_UNITS  = ['', 'א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט'];
const _HEB_TENS   = ['', 'י', 'כ', 'ל', 'מ', 'נ', 'ס', 'ע', 'פ', 'צ'];
const _HEB_HUNDS  = ['', 'ק', 'ר', 'ש', 'ת', 'תק', 'תר', 'תש', 'תת', 'תתק'];
export const toHebrewYear = (y) => {
  if (!y) return '';
  const rem = y % 1000;
  const h = Math.floor(rem / 100);
  const t = Math.floor((rem % 100) / 10);
  const u = rem % 10;
  let s = (_HEB_HUNDS[h] || '') + (_HEB_TENS[t] || '') + (_HEB_UNITS[u] || '');
  s = s.replace('יה', 'טו').replace('יו', 'טז');
  if (s.length >= 2) s = s.slice(0, -1) + '״' + s.slice(-1);
  else if (s.length === 1) s += '׳';
  return s;
};

export const PARNAS_TYPES = [
  { value: 'maor',         label: 'מאור',                defaultIcon: 'star'      },
  { value: 'kafe',         label: 'קפה',                 defaultIcon: 'stories'   },
  { value: 'achzakat',     label: 'אחזקת בית המדרש',     defaultIcon: 'pillars'   },
  { value: 'avot_uvanim',  label: 'אבות ובנים',           defaultIcon: 'groups'    },
  { value: 'acher',        label: 'אחר',                 defaultIcon: 'sparkle'   },
];

export const PARNAS_TYPE_LABELS = {
  maor:        'מאור',
  kafe:        'קפה',
  achzakat:    'אחזקת בית המדרש',
  avot_uvanim: 'אבות ובנים',
  acher:       'אחר',
};

export const PARNAS_TYPE_DEFAULT_ICONS = {
  maor:        'star',
  kafe:        'stories',
  achzakat:    'pillars',
  avot_uvanim: 'groups',
  acher:       'sparkle',
};

export const SLOT_TYPE_LABELS = {
  daily:   'נציב יום',
  weekly:  'נציב שבוע',
  monthly: 'נציב חודש',
};

export const SLOT_TYPE_COLORS = {
  daily:   '#1e3a5f',
  weekly:  '#7c3aed',
  monthly: '#065f46',
};

export const HEBREW_MONTH_NAMES = {
  1:  'ניסן',
  2:  'אייר',
  3:  'סיון',
  4:  'תמוז',
  5:  'אב',
  6:  'אלול',
  7:  'תשרי',
  8:  'חשון',
  9:  'כסלו',
  10: 'טבת',
  11: 'שבט',
  12: 'אדר',
  13: 'אדר ב׳',
};

export const MONTH_NAME_TO_NUM = {
  'Nisan': 1,
  'Iyar': 2, 'Iyyar': 2,
  'Sivan': 3,
  'Tamuz': 4, 'Tammuz': 4,
  'Av': 5,
  'Elul': 6,
  'Tishrei': 7, 'Tishri': 7,
  'Cheshvan': 8, 'Marcheshvan': 8,
  'Kislev': 9,
  'Tevet': 10,
  'Shvat': 11, "Sh'vat": 11,
  'Adar': 12, 'Adar1': 12, 'Adar I': 12,
  'Adar2': 13, 'Adar II': 13,
};

export const PARNAS_WIDGET_WIDTH  = 400;
export const PARNAS_WIDGET_HEIGHT = 300;

// ─── Hebrew day number labels 1–30 ───────────────────────────────────────────
export const HEB_DAY_NUMS = [
  '', 'א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ז׳', 'ח׳', 'ט׳', 'י׳',
  'י"א', 'י"ב', 'י"ג', 'י"ד', 'ט"ו', 'ט"ז', 'י"ז', 'י"ח', 'י"ט',
  'כ׳', 'כ"א', 'כ"ב', 'כ"ג', 'כ"ד', 'כ"ה', 'כ"ו', 'כ"ז', 'כ"ח', 'כ"ט', 'ל׳',
];

// ─── Convert hebcal hd/hm to Hebrew date label ───────────────────────────────
export function toHebDateLabel(hd, hm) {
  const monthNum = MONTH_NAME_TO_NUM[hm];
  const monthHeb = HEBREW_MONTH_NAMES[monthNum] || hm;
  return `${HEB_DAY_NUMS[hd] || hd} ${monthHeb}`;
}

// ─── Cached hebcal date converter (module-level, persists for session) ────────
const _hebDateCache    = {};
const _hebDateInFlight = {};

export function fetchHebDateLabel(isoDate) {
  if (_hebDateCache[isoDate] !== undefined) return Promise.resolve(_hebDateCache[isoDate]);
  if (_hebDateInFlight[isoDate]) return _hebDateInFlight[isoDate];

  const promise = fetch(
    `https://www.hebcal.com/converter?cfg=json&date=${isoDate}&g2h=1`
  )
    .then(r => r.json())
    .then(d => {
      const label = toHebDateLabel(d.hd, d.hm);
      _hebDateCache[isoDate] = label;
      delete _hebDateInFlight[isoDate];
      return label;
    })
    .catch(() => {
      _hebDateCache[isoDate] = '';
      delete _hebDateInFlight[isoDate];
      return '';
    });

  _hebDateInFlight[isoDate] = promise;
  return promise;
}
